export const steps = [
  "Etape 1",
  "Etape 2",
  "Visualisation",
  "Paiement",
  "Done",
];
